import { render, staticRenderFns } from "./BatchAdjust.vue?vue&type=template&id=05640252&scoped=true"
import script from "./BatchAdjust.vue?vue&type=script&lang=js"
export * from "./BatchAdjust.vue?vue&type=script&lang=js"
import style0 from "./BatchAdjust.vue?vue&type=style&index=0&id=05640252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05640252",
  null
  
)

export default component.exports